const FACEBOOK_PIXEL_URL = 'https://connect.facebook.net/en_US/fbevents.js';
const MOBILE_USER_AGENT_PATTERN = /android|iphone|ipod|iemobile|mobile/i;

let analyticsBootstrapped = false;
let facebookPixelRequested = false;

function debugMode() {
  return window.RailsConfig?.appDebug === true;
}

function debugLog(...args) {
  if (debugMode()) {
    console.info(...args);
  }
}

function initializeFacebookPixel(pixelId) {
  if (!pixelId || facebookPixelRequested) return;

  facebookPixelRequested = true;

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    t.onload = () => debugLog('Facebook Pixel loaded');
    t.onerror = () => debugLog('Facebook Pixel failed to load');
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', FACEBOOK_PIXEL_URL);

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}

function initializeAnalytics() {
  if (analyticsBootstrapped) return;

  analyticsBootstrapped = true;

  if (window.userAnalytics) {
    window.userAnalytics.load(window.RailsConfig?.MixpanelToken, {
      tracker: 'mixpanel',
      debug: window.RailsConfig?.appDebug,
    });

    window.userAnalytics._trackEvent = window.userAnalytics.trackEvent;
    window.userAnalytics.trackEvent = function (name, properties, options, callback) {
      if (properties === undefined) {
        properties = {};
      }
      if (!Object.prototype.hasOwnProperty.call(properties, 'product')) {
        properties.product = MOBILE_USER_AGENT_PATTERN.test(window.navigator.userAgent)
          ? 'web-mobile'
          : 'web';
      }
      window.userAnalytics._trackEvent(name, properties, options, callback);
    };

    window.userAnalytics.analyticsReady(function () {
      window.userAnalytics.gaTracker.setUserType('Anonymous');
    });
  } else {
    debugLog('user-analytics library not loaded, Mixpanel tracking disabled');
  }

  initializeFacebookPixel(window.RailsConfig?.fbPixelID);
  window.scriptLoader?.fireEvent('loadAnalytics');
  window.eventLoader?.fireEvent('analytics-loaded');
}

function onReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

onReady(() => {
  window.addEventListener('focus', initializeAnalytics, { once: true });
  window.addEventListener('scroll', initializeAnalytics, { once: true, passive: true });
  document.body?.addEventListener('mouseover', initializeAnalytics, {
    once: true,
    passive: true,
  });
});
